import { Button } from '@fluentui/react-components';
import { ArrowLeftRegular } from '@fluentui/react-icons';
import { useAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';
import { ClientOnboardingFormAtom, DefaultClientOnboardingForm } from '../../store/ClientOnboardingFormAtom';
import BrandHeader from './BrandHeader';

const TopBar = () => {
    const navigate = useNavigate();
    const [, setClientOnboardingForm] = useAtom(ClientOnboardingFormAtom);

    const onReturnClick = () => {
        setClientOnboardingForm(DefaultClientOnboardingForm);
        navigate('/Recent');
    };

    return (
        <BrandHeader title="Create Client">
            <Button icon={<ArrowLeftRegular />} onClick={onReturnClick}>
                Return to Client List
            </Button>
        </BrandHeader>
    );
};

export default TopBar;
